import React from 'react'
import { connect } from 'react-redux'
import {
  Field, formValueSelector, reduxForm, change as changeFieldValue
} from 'redux-form';
import Pessoa from './Pessoa';
import { apenasNumero, renderFieldCpfCnpj, validarCpfCnpj } from '../../util/inputs';
import ModalCadastroPessoa from './ModalCadastroPessoa';
import selecionarEnderecoDestinatario from '../../actions/endereco/selecionarEnderecoDestinatario';
import buscarPessoaDestinatarioPorCpfCnpj from '../../actions/pessoa/buscarPessoaDestinatarioPorCpfCnpj';
import selecionarPessoaDestinatario from '../../actions/pessoa/selecionarPessoaDestinatario';
import recuperarPessoaPorCpfCnpj from '../../actions/pessoa/recuperarPessoaPorCpfCnpj';

const selector = formValueSelector('formularioCadastroEncomenda');

export class AbaDestinatario extends React.Component {
  limparFormularioPessoa () {
    this.props.changeFieldValue('formularioCadastroPessoa',
      'nome', '');
    this.props.changeFieldValue('formularioCadastroPessoa',
      'cpfCnpj', this.props.cpfCnpjDestinatario);
    this.props.changeFieldValue('formularioCadastroPessoa',
      'email', '');
    this.props.changeFieldValue('formularioCadastroPessoa',
      'telefone', '');
  }

  exibirPessoa () {
    if (this.props.pessoaDestinatario && this.props.pessoaDestinatario.id) {
      return <Pessoa pessoa={this.props.pessoaDestinatario}
                     selecionarEnderecoRemetenteDestinatario={this.props.selecionarEnderecoDestinatario}
                     enderecoSelecionado={this.props.enderecoDestinatario}
                     buscarPessoa={this.props.buscarPessoaDestinatarioPorCpfCnpj}/>;
    }
    if (!this.props.pessoaDestinatario) {
      return (
        <div className="alert alert-warning mt-4 text-center" role="alert">
          <div className='col-md-12'>Nenhuma pessoa encontrada para o CPF/CNPJ: {this.props.cpfCnpjDestinatario}</div>
          <a data-toggle="modal" data-target="#modalCadastrarPessoa" className='col-md-12' style={{ color: '#0789dd' }}
             onClick={() => { this.limparFormularioPessoa(); this.buscarUsuarioPorCpf() }}>Clique aqui para cadastrar.</a>
        </div>

      )
    }
  }

  buscarUsuarioPorCpf () {
    this.props.recuperarPessoaPorCpfCnpj(apenasNumero(this.props.cpfCnpjDestinatario)).then((resp) => {
      if (resp.payload.data !== '' && resp.payload.status === 200) {
        this.props.changeFieldValue('formularioCadastroPessoa', 'nome', resp.payload.data.nome);
      } else {
        this.props.changeFieldValue('formularioCadastroPessoa', 'nome', '');
      }
    })
  }

  zerar (e) {
    this.props.selecionarEnderecoDestinatario(null);
    if (!this.props.cpfCnpjDestinatario || e.target.value.trim().length < this.props.cpfCnpjDestinatario.trim().length) {
      this.props.selecionarPessoaDestinatario({});
    }
  }

  render () {
    return (
      <div className="vx-enc-flow">
        <div className="vx-search-card">
          <div className="vx-enc-section-header">
            <div className="vx-enc-section-title">
              <i className="material-icons">person_pin</i>
              Identificação do Destinatário
            </div>
          </div>
          <div className="vx-enc-search-row">
            <div style={{ flex: '1 1 260px', maxWidth: 340 }}>
              <Field name='cpfCnpjDestinatario' type="text" component={renderFieldCpfCnpj} label="CPF / CNPJ" validate={[validarCpfCnpj]}
                css="form-control" readOnly={false} onChange={e => this.zerar(e)}/>
            </div>
            <button className="vx-btn-buscar" style={{ width: 'auto', flexShrink: 0 }}
              onClick={() => this.props.buscarPessoaDestinatarioPorCpfCnpj(this.props.cpfCnpjDestinatario)}
              disabled={apenasNumero(this.props.cpfCnpjDestinatario).length !== 11 && apenasNumero(this.props.cpfCnpjDestinatario).length !== 14}>
              <i className="material-icons">search</i>
              Buscar
            </button>
          </div>
        </div>
        {this.exibirPessoa()}
        <ModalCadastroPessoa buscarPessoa={this.props.buscarPessoaDestinatarioPorCpfCnpj}/>
      </div>
    )
  }
}


export const mapStateToProps = state => (
  {
    empresaSelecionada: state.empresaSelecionada,
    cpfCnpjDestinatario: selector(state, 'cpfCnpjDestinatario'),
    enderecoDestinatario: state.enderecoDestinatario,
    pessoaDestinatario: state.pessoaDestinatario,
    initialValues: {
      cpfCnpjDestinatario: state.pessoaDestinatario.cpfCnpj

    }
  });


export default connect(mapStateToProps, {
  selecionarEnderecoDestinatario,
  recuperarPessoaPorCpfCnpj,
  buscarPessoaDestinatarioPorCpfCnpj,
  selecionarPessoaDestinatario,
  changeFieldValue
})(reduxForm({
  form: 'formularioCadastroEncomenda',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AbaDestinatario))
